import type {Editor} from 'grapesjs';
import {importComponents} from './src/form-maker-component';
import {importStorage} from './src/form-maker-storage';
import {importCommands} from './src/form-maker-commands';
import {initListeners} from './src/form-maker-listeners';

export default function formMakerPlugin(editor: Editor): void {
  importComponents(editor);
  importStorage(editor);
  importCommands(editor);
  initListeners(editor);
}
